import ButtonBase from "../Buttons/ButtonBase";
import { useState } from "react";
interface ICopyButtonProps {
  btnText?: string | any;
  copiedValue: string;
  className?: string;
}
function CopyButton({ btnText, copiedValue, className }: ICopyButtonProps) {
  const [copy, setCopy] = useState(false);
  const handleClick = async () => {
    await navigator.clipboard.writeText(copiedValue);
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 2000);
  };
  return (
    <ButtonBase
      type="button"
      buttonType="secondary"
      onClick={handleClick}
      className={`px-2  text-xs ${className}`}
      icon={!copy ? <></> : <></>}
      text={copy ? "Copied" : btnText}
    />
  );
}
export default CopyButton;
